export default __webpack_public_path__ + "static/media/learn-earn-hero-toaster.cd35653f.svg";